import { Card, CardProps } from "@mui/material";
import { SxProps, Theme } from "@mui/system";
import React from "react";

export interface GenericCardProps extends Omit<CardProps, "sx"> {
  /** you can still pass additional sx if you wish */
  sx?: SxProps<Theme>;
}

/**
 * A Card with a 1px grey border, no shadow, and radius=2.
 */
export const CardCustom: React.FC<GenericCardProps> = ({ sx, ...props }) => {
  return (
    <Card
      sx={[
        {
          border: "1px solid hsl(var(--border))",
          borderRadius: 2,
          boxShadow: "none",
          bgcolor: "hsl(var(--card))",
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...props}
    />
  );
};
